define([
    "dojo/_base/declare",
    "csi/_base/underscore",
	"csi/session",
	"csi/state",
    "csi/store/Nodes",
    "csi/table/matrix/Path",
    "csi/xml",
    "csi/xml/Query"
], function(declare,_,session,state,Nodes,PathMatrix,xml,Query) {

	return declare(PathMatrix, {

		/**
		 * add any dependency paths necessary to process matrix
		 * @param {Heading}
		 * @param {String[]}
		 */
		addDependencyPaths: function(h, paths) {
			paths.push("Child:__Parent__/Child:__Parent__/Child:ProductSalesRegions");
			paths.push("Child:__Parent__/Child:__Parent__/Child:ProductSalesRegions/Child:ProductSalesRegionSpec");
			paths.push("Child:__Parent__/Child:__Parent__/Child:ProductSalesRegions/Child:ProductSalesRegionSpec/Child:SellingCountries");
			paths.push("Child:__Parent__/Child:__Parent__/Child:ProductSalesRegions/Child:ProductSalesRegionSpec/Child:SellingCountries/Child:Languages");
			this.inherited(arguments);
		},

        addDeferred: function(/*Context*/ctx, /*Heading*/h, /*Deferred[]*/dfds) {
            // summary: add any deferreds for languages
            var languageStore = new Nodes({
                sortQuery: new Query().SortByAttr("SortOrder"),
                typeNode: "Language",
                cachingStore: ctx.cache
            });

            dfds.push(languageStore.query());

            var activeProductSalesRegionURL = ctx.view.activeProductSalesRegion;

            if (activeProductSalesRegionURL) {
                // get the countries of the ProductSalesRegionSpec of the selected ProductSalesRegion
                var countriesStore = new Nodes({
                    typeNode: "Country",
                    requestParameters: {
                        "Qry.Limit.Path": xml.getUrlPath(activeProductSalesRegionURL, xml.path("ProductSalesRegionSpec","SellingCountries"))
                    },
                    cachingStore: ctx.cache
                });

                dfds.push(countriesStore.query());

                this.productSalesRegion = ctx.cache.getNode(activeProductSalesRegionURL);

                if (this.productSalesRegion)
                    dfds.push(ctx.cache.getNodeDeferred(this.productSalesRegion.ProductSalesRegionSpec));
            }
        },

        _getRowNodes: function(/*Context*/ctx, /*QueryResult*/qr, /*Spec*/c, /*Node*/ node) {

            this.productSalesRegionSpec = this.productSalesRegion ? ctx.cache.getNode(this.productSalesRegion.ProductSalesRegionSpec) : null;

			if (state.get("print") && !state.get("printAdHoc")) {
				var url = session.getLocationValue("ProductSalesRegion");

				if (xml.isValidURL(url)) {
					this.productSalesRegionSpec = ctx.cache.getNode(ctx.cache.getNode(url).ProductSalesRegionSpec);
				}
			}

            var languages = [];
            if (this.productSalesRegionSpec) {
                _.each(this.productSalesRegionSpec.SellingCountries, function(countryURL) {
                    var country = ctx.cache.getNode(countryURL);
                    languages = languages.concat(ctx.cache.getNodes(country.Languages));
                });
            }

            return languages;
        }

    });
});